import { getAccessedAppPolicy } from "../api/apps";
import { getAccessedAssetPolicy } from "../api/asset";
import { getAccessedWebAppPolicy } from "../api/web_app";

const getPolicydata = async (resource_type, resource_id, systemuser_id = null) => {
  if (resource_type === "apps") {
    return await getAccessedAppPolicy({
      app_id: resource_id,
      system_user: systemuser_id,
    });
  } else if (resource_type === "assets") {
    return await getAccessedAssetPolicy({
      asset_id: resource_id,
      system_user: systemuser_id,
    });
  } else if (resource_type === "web_apps") {
    return await getAccessedWebAppPolicy({
      webapp_id: resource_id,
      system_user: systemuser_id,
    });
  }
};

export const getAccessedResourcePolicy = async (
  resource_type,
  resource_id,
  systemuser_id,
) => {
  const { data, error } = await getPolicydata(
    resource_type,
    resource_id,
    systemuser_id,
  );
  return { data, error };
};
